import { IMG } from "@/data/content";

// Primary Education Center categories. Add one here and it appears across the hub.
export const CATEGORIES = [
  {
    slug: "commercial-electricity",
    label: "Commercial Electricity",
    icon: "Zap",
    color: "#0052FF",
    image: IMG.transmissionDay,
    tagline: "How businesses buy, manage, and optimize electricity.",
    description:
      "Everything commercial decision-makers need to understand about procuring and managing electricity — from contract structures and buying strategy to the charges that drive your bill.",
  },
  {
    slug: "commercial-natural-gas",
    label: "Commercial Natural Gas",
    icon: "Flame",
    color: "#00C853",
    image: IMG.gas,
    tagline: "Procuring and hedging natural gas with confidence.",
    description:
      "A practical guide to commercial natural gas — supply procurement, seasonality, hedging, and the market dynamics that shape what your business pays.",
  },
  {
    slug: "battery-hosting",
    label: "Battery Hosting",
    icon: "BatteryCharging",
    color: "#06B6D4",
    image: IMG.battery,
    tagline: "Turning land and rooftops into energy assets.",
    description:
      "How grid-scale battery storage works, why it's expanding, and how landowners and facility operators in Texas and Illinois can evaluate hosting opportunities.",
  },
  {
    slug: "energy-procurement",
    label: "Energy Procurement",
    icon: "Handshake",
    color: "#0052FF",
    image: IMG.boardroom,
    tagline: "The strategy and process behind buying energy well.",
    description:
      "Procurement is a discipline, not a transaction. Learn contract structures, pricing models, timing, and the process that protects your budget.",
  },
  {
    slug: "utility-bills",
    label: "Utility Bills",
    icon: "ReceiptText",
    color: "#0052FF",
    image: IMG.officeTower,
    tagline: "Decoding every line on your commercial bill.",
    description:
      "Commercial energy bills are complex by design. Understand energy vs. demand, capacity and transmission charges, delivery costs, and how to read your usage data.",
  },
  {
    slug: "energy-markets",
    label: "Energy Markets",
    icon: "LineChart",
    color: "#00C853",
    image: IMG.marketAbstract,
    tagline: "How wholesale markets and deregulation shape prices.",
    description:
      "From deregulation and grid operators to capacity auctions and price drivers — the market context every commercial energy buyer should understand.",
  },
  {
    slug: "state-energy-guides",
    label: "State Energy Guides",
    icon: "MapPin",
    color: "#06B6D4",
    image: IMG.glassFacade,
    tagline: "Market-by-market guides across the U.S.",
    description:
      "Energy rules are set state by state. Explore commercial energy guidance for each market we serve, including grid operators and service availability.",
    external: "/service-areas",
  },
  {
    slug: "industry-energy-guides",
    label: "Industry Energy Guides",
    icon: "Building2",
    color: "#0052FF",
    image: IMG.manufacturing,
    tagline: "Energy strategy tailored to your sector.",
    description:
      "How energy procurement applies across manufacturing, real estate, hospitality, healthcare, logistics, and data centers.",
    external: "/industries",
  },
  {
    slug: "glossary",
    label: "Commercial Energy Glossary",
    icon: "BookMarked",
    color: "#00C853",
    image: IMG.dataCenter,
    tagline: "Plain-language definitions of key energy terms.",
    description:
      "A searchable glossary of commercial energy terminology — each term explained clearly, with why it matters and where to learn more.",
    external: "/education/glossary",
  },
];
